import React, { useState } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false); // Tambahkan state untuk dropdown

  const handleToHome = () => {
    window.location.href = "/";
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen); // Fungsi untuk toggle dropdown alumni
  };

  return (
    <React.Fragment>
      <div className="container-navbar">
        <img
          src="https://tarunapersada.com/assets/img/logo/logo_atas.png"
          alt="Logo Bimbel Masuk Akpol"
          className="logo-navbar"
          onClick={handleToHome}
        />
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <div className={`line ${menuOpen ? "line1" : ""}`}></div>
          <div className={`line ${menuOpen ? "line2" : ""}`}></div>
          <div className={`line ${menuOpen ? "line3" : ""}`}></div>
        </div>
        <ul className={`parent-item-navbar ${menuOpen ? "open" : ""}`}>
          <a href="/" className="item-navbar">
            Beranda
          </a>
          <a href="#paket" className="item-navbar">
            Paket
          </a>
          <li className="item-navbar" onClick={toggleDropdown}>
            {" "}
            {/* Alumni sebagai li dengan event klik */}
            <div className="child-item-navbar">
              Program{" "}
              <span
                className={`material-symbols-outlined ${
                  dropdownOpen ? "rotate" : ""
                }`}
              >
                arrow_drop_down
              </span>
            </div>
            {dropdownOpen /* Dropdown hanya muncul jika dropdownOpen true */ && (
              <ul className="dropdown-menu">
                <li className="dropdown-item">
                  <a
                    href="/bimbel-akpol"
                    className="parent-dropdown-nav"
                  >
                    <span className="material-symbols-outlined">
                      local_police
                    </span>
                    Program Akpol
                  </a>
                </li>
                <li className="dropdown-item">
                  <a
                    href="/bimbel-akmil"
                    className="parent-dropdown-nav"
                  >
                    <span className="material-symbols-outlined">
                      local_police
                    </span>
                    Program Akmil
                  </a>
                </li>
                <li className="dropdown-item">
                  <a
                    href="/bimbel-bintara"
                    className="parent-dropdown-nav"
                  >
                    <span className="material-symbols-outlined">
                      local_police
                    </span>
                    Program Bintara TNI Polri
                  </a>
                </li>
                <li className="dropdown-item">
                  <a
                    href="/bimbel-sekolah-kedinasan/"
                    className="parent-dropdown-nav"
                  >
                    <span className="material-symbols-outlined">
                      local_police
                    </span>
                    Program Sekolah Kedinasan
                  </a>
                </li>
              </ul>
            )}
          </li>
          <a href="#testimoni" className="item-navbar">
            Testimoni
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=6281216365729&text=Halo%20Kak%20Nia%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20Bimbel%20TNI-POLRI%20Bagaimana%20penjelasan%20detail%20Programnya?"
            className="btn-navbar"
          >
            Daftar Sekarang
          </a>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default Navbar;
